





















import IconNoSearchResult from "@/common/components/icons/IconNoSearchResult.vue";
import { Prop, Vue, Component } from "vue-property-decorator";
import globals from "@/general/store/modules/globals";

@Component({
  components: {
    IconNoSearchResult
  }
})
export default class ThanksPointListSearchNotFound extends Vue {
  @Prop({ type: String, default: "" }) keyword!: string;

  searchKeyword = "";
  currentPagedoSearch!: number;

  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const search = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : undefined;
    this.searchKeyword = this.keyword || search || "";
  }
  get locationSearch() {
    const search = document.location as unknown;
    const encodeSearchKeyword = decodeURIComponent(search as string);
    const keyword = encodeSearchKeyword.replace(/\+/g, " ");
    return keyword.split("=")[1];
  }

  get iconSize() {
    const isSp = globals.isSpScreenWidth;

    if (isSp) {
      return 103;
    } else {
      return 158;
    }
  }
}
